import React, { useEffect } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

import { useModal } from '@europrocurement/flexy-components';
import { useFormaliteService, type DocTypeEnumType } from '@europrocurement/l2d-domain';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@europrocurement/flexy-components/redux/storeConfig/store';
import { capitalizeFirstLetter } from '@europrocurement/l2d-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faTag } from '@fortawesome/pro-regular-svg-icons';
import { type DocumentType } from '../validation/DossierDocumentTypeSelect/DossierDocumentTypeSelect';
import DocumentTypeForm from '../../shared/DocumentTypeForm/DocumentTypeForm';

export type DossierDocumentValidationDocumentTypeProps = {
    onDocumentTypeChange: (type: DocumentType) => void;
    isSubmitting: boolean;
    typeDocType?: DocTypeEnumType;
    label?: string;
};
const DossierDocumentValidationDocumentType: React.FunctionComponent<DossierDocumentValidationDocumentTypeProps> =
    function ({ onDocumentTypeChange, isSubmitting = false, typeDocType, label }) {
        const { modalActions } = useModal();
        const dispatch = useDispatch<AppDispatch>();
        const { getFormaliteDocuments } = useFormaliteService();
        const { palette } = useTheme();

        // Fetch documents
        useEffect(() => {
            dispatch(getFormaliteDocuments({}));
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        const handleClick = () => {
            if (typeDocType && !isSubmitting) {
                modalActions.call(
                    <DocumentTypeForm
                        title="Sélectionner de type de document"
                        itemsSelected={[]}
                        type={typeDocType}
                        handleSelectItems={onDocumentTypeChange}
                        singleChoice
                    />,
                );
            }
        };

        return (
            <Box
                sx={{
                    display: 'flex',
                    gap: '0 14px',
                    alignItems: 'center',
                    marginLeft: '20px',
                }}
                onClick={() => handleClick()}
            >
                <Box
                    sx={{
                        height: '23px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0 4px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        border: `1px solid ${palette.grey[700]}`,
                        backgroundColor: palette.grey[200],
                        borderRadius: '8px',
                        padding: '16px 8px',
                        cursor: 'pointer',
                        '&:hover': {
                            border: `1px solid ${palette.primary.main}`,
                        },
                    }}
                >
                    <FontAwesomeIcon icon={faTag} />

                    <Typography
                        component="span"
                        variant="caption"
                        sx={{
                            height: '23px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0 6px',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            maxWidth: '120px',
                        }}
                    >
                        {label && capitalizeFirstLetter(label)}
                    </Typography>
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        fontSize="8px"
                    />
                </Box>
            </Box>
        );
    };

export default DossierDocumentValidationDocumentType;
